import { normalizeResolvedPath } from '../../paths/normalize-resolved-path.js';
import type { SessionWorktreeBinding } from '../session-worktree-binding.js';

export class SessionWorktreeCache {
  private readonly sessionRepoCheckoutPaths = new Map<string, string[]>();
  private readonly sessionParentPathBySession = new Map<string, string>();

  remember(sessionId: string, binding: SessionWorktreeBinding): void {
    const paths = binding.repoCheckoutPaths.map((p) => normalizeResolvedPath(p));
    this.sessionRepoCheckoutPaths.set(sessionId, paths);
    this.sessionParentPathBySession.set(sessionId, normalizeResolvedPath(binding.sessionParentPath));
  }

  clearSession(sessionId: string): string[] | undefined {
    const paths = this.sessionRepoCheckoutPaths.get(sessionId);
    this.sessionRepoCheckoutPaths.delete(sessionId);
    this.sessionParentPathBySession.delete(sessionId);
    return paths;
  }

  getSessionParentPath(sessionId: string): string | undefined {
    return this.sessionParentPathBySession.get(sessionId);
  }

  hasSession(sessionId: string): boolean {
    return this.sessionParentPathBySession.has(sessionId);
  }

  getRepoCheckoutPaths(sessionId: string): string[] | undefined {
    const paths = this.sessionRepoCheckoutPaths.get(sessionId);
    return paths?.length ? [...paths] : undefined;
  }

  getRepoCheckoutPathsRef(sessionId: string): string[] | undefined {
    const paths = this.sessionRepoCheckoutPaths.get(sessionId);
    return paths?.length ? paths : undefined;
  }
}
